import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '22px',
  color: 'text.primary',
});
